import { useTranslation } from 'next-i18next'

import ErrorMessage from '~/components/Error/ErrorMessage'

import useRegisterContext from '../hooks/useRegisterContext'

interface RegisterServerError {
  email_in_user: 'errors:emailInUse'
  email_invalid: 'errors:emailInvalid'
  userDoesNotExist: 'errors:userDoesNotExist'
  passwordIncorrect: 'errors:passwordIncorrect'
}
const ERROR_MAPPING: RegisterServerError = {
  email_in_user: 'errors:emailInUse',
  email_invalid: 'errors:emailInvalid',
  userDoesNotExist: 'errors:userDoesNotExist',
  passwordIncorrect: 'errors:passwordIncorrect',
}

function getServerError(error: string): RegisterServerError[keyof RegisterServerError] | 'errors:unknown' {
  if (error in ERROR_MAPPING) {
    return ERROR_MAPPING[error as keyof RegisterServerError]
  } else {
    return 'errors:unknown'
  }
}

export default function RegisterServerError(): React.ReactElement | null {
  const { t } = useTranslation(['errors', 'register'])
  const { backendError } = useRegisterContext()

  if (!backendError) {
    return null
  }

  return <ErrorMessage>{t(getServerError(backendError))}</ErrorMessage>
}
